import axios from '../utils/ajax'
// import {getCookie} from '../utils/cookie'

// 注册
export const getRegister = params => {
  return axios.post(`/jeecg-boot/account/register`, params).then(res => res.data).catch(function () {})
}

// 注册校验用户名是否重复
export const verifyUserName = params => {
  return axios.get('/jeecg-boot/account/validateAccountName', params).then(res => res.data).catch(function () {})
}

// 注册校验手机号码是否重复
export const verifyMobilePhone = params => {
  return axios.get('/jeecg-boot/account/validateMobile', params).then(res => res.data).catch(function () {})
}

// 获取验证码
export const getVerifyCode = params => {
  return axios.get(`/jeecg-boot/code/${params.type}`, params).then(res => res.data).catch(err => console.log(err))
}

// 重置密码
export const updatePwd = params => {
  return axios.post('/jeecg-boot/accountcenter/account/updatePassword', params).then(res => res.data).catch(err => console.log(err))
}

// 重置密码
export const updatePassword = params => {
  return axios.post('/jeecg-boot/account/updatePassword', params).then(res => res.data).catch(err => console.log(err))
}

// 小瓜云展列表
export const getXgyzList = () => {
  return axios.get('/jeecg-boot/accountcenter/exhibition').then(res => res.data).catch(err => console.log(err))
}

// 查看企业信息
export const getOrganizationInfo = params => {
  return axios.get('/jeecg-boot/accountcenter/organization', params).then(res => res.data).catch(err => console.log(err))
}

// 添加企业信息
export const addOrganizationInfo = params => {
  return axios.post('/jeecg-boot/accountcenter/organization', params).then(res => res.data).catch(err => console.log(err))
}

// 修改企业信息
export const editOrganizationInfo = params => {
  return axios.post('/jeecg-boot/accountcenter/organization/editInfo', params).then(res => res.data).catch(err => console.log(err))
}

// 提交企业信息
export const putOrganizationInfo = params => {
  return axios.put('/jeecg-boot/accountcenter/organization', params).then(res => res.data).catch(err => console.log(err))
}

// 根据id获取企业信息
export const getExhibitionInfo = params => {
  return axios.get('/jeecg-boot/kugua/api/getOrganizationByExhibitId', params).then(res => res.data).catch(err => console.log(err))
}

// sso快速登录
export const quickLogin = params => {
  return axios.get('/jeecg-boot/kugua/api/cas', params).then(res => res.data).catch(err => console.log(err))
}

// 发布流程跳转接口
export const goSSOLink = () => {
  return axios.get('/jeecg-boot/accountcenter/exhibition/loginUrl').then(res => res.data).catch(err => console.log(err))
}



// WEBPACK FOOTER //
// ./src/api/api.js